import { Injectable } from '@angular/core';
import { ColorVariant, MobilePhoneSearchItem } from '../models/mobilephone-search-item';
import { HardwareVariant } from '../models/mobilephone-variant';

@Injectable({
  providedIn: 'root',
})
export class MobilephoneSearchHelperService {
  getCurrentColorVariant(currentSelectedVariant: MobilePhoneSearchItem): ColorVariant {
    return currentSelectedVariant.colorVariants.find(item => item.offeringId === currentSelectedVariant.offeringId);
  }

  getCheapestVariantFromGroupVariants(mobilePhoneVariants: HardwareVariant[]): HardwareVariant {
    return mobilePhoneVariants?.reduce(
      (cheapestItem, currentItem) => (currentItem.priceFrom < cheapestItem.priceFrom ? currentItem : cheapestItem),
      mobilePhoneVariants[0]
    );
  }

  public static hasVariantOptions(mobilePhoneVariant: HardwareVariant): boolean {
    const unknownOptionString = 'Unknown';
    return mobilePhoneVariant?.color !== unknownOptionString && mobilePhoneVariant?.memorySize !== unknownOptionString;
  }

  getCheapestVariantAvailableForPurchaseFromGroupVariants(mobilePhoneVariants: HardwareVariant[]): HardwareVariant {
    const availableVariants = mobilePhoneVariants?.filter(
      variant => variant.backorderInfo?.allow || variant.quantityInStock > 0
    );
    return this.getCheapestVariantFromGroupVariants(availableVariants);
  }
}
